import { useEffect, useRef } from 'react'
import SectionHeading from './SectionHeading'
import { PHILOSOPHIES } from '../data/philosophy'
import { initGSAP, prefersReducedMotion } from '../lib/motion'

const Principles: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (prefersReducedMotion()) return
    const gsapApi = initGSAP()
    const ctx = gsapApi.context(() => {
      gsapApi.fromTo(
        '[data-principle]',
        { opacity: 0, y: 16 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.06,
          scrollTrigger: { trigger: ref.current, start: 'top 82%', once: true },
        }
      )
    }, ref)
    return () => ctx.revert()
  }, [])

  return (
    <section
      id="principles"
      ref={ref}
      className="section-padding bg-neutral-50 dark:bg-neutral-900/30"
    >
      <div className="container-width">
        <SectionHeading
          label="How I work"
          meta="principles"
          title={
            <>
              Operating <span className="text-gradient">principles</span>
            </>
          }
          description="The commitments that shape every platform I build — held the same way in infrastructure, delivery and production operations."
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {PHILOSOPHIES.map((principle, i) => (
            <div
              key={principle.title}
              data-principle
              className="relative rounded-2xl border border-neutral-200 dark:border-white/10 bg-white dark:bg-neutral-900 p-5"
            >
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-primary-500">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-2 font-display text-base font-semibold tracking-tight">
                {principle.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-neutral-600 dark:text-neutral-400">
                {principle.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Principles